module.exports = __webpack_public_path__ + "static/img/tc_logo1.e6652606.png";